// extracted by mini-css-extract-plugin
module.exports = {"button":"CookieConsentAcceptButton_button__aEgCZ","text":"CookieConsentAcceptButton_text__VEKoC"};